module.exports = __webpack_public_path__ + "static/media/16_Platzek_webfinal.fb488ee8.jpg";